__webpack_require__.p = "/styleguide/";